import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import { GiftRecommendedItemRow } from '@models/item/recommendedItem';
import { Link } from '@router/Link';

import styles from './styles.module.scss';

interface Props {
    item: GiftRecommendedItemRow;
}

function GiftItem({ item }:Props) {
    const {
        name, salePrice, thumbnailUrl, itemId,
    } = item;
    return (
        <Link activityName='GiftItemActivity'
            activityParams={{ giftItemId: itemId }}>
            <Column align='center' className={styles.container}>
                <div className={styles.imageWrapper}>
                    <Image src={thumbnailUrl}
                        width={88}
                        height={88}
                        alt={name} />
                </div>
                <Text>{name}</Text>
                <Text size='lg' fontWeight='bold'>
                    {salePrice.toLocaleString()}
                </Text>
            </Column>
        </Link>
    );
}

export default GiftItem;
